import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CARD_SUIT_BLUE_COLOR, CARD_SUIT_RED_COLOR } from '../../../styles/colors';
const BASE_EM_SIZE = 1.3;
export const DiamondShape = ({ emSize = 1, isFourColorDeck, overrideColor }) => {
    const sizeStr = `${emSize * BASE_EM_SIZE}em`;
    return (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 52.2153 82.6701', width: sizeStr, height: sizeStr, fill: overrideColor || (isFourColorDeck ? CARD_SUIT_BLUE_COLOR : CARD_SUIT_RED_COLOR), children: _jsx("polygon", { points: '26.109 82.67 0 41.336 26.109 0 52.215 41.336 26.109 82.67' }) }));
};
